export default "__VITE_ASSET__CwotquvE__"